import { getAxiosConfigUserToken, sortByProperty } from 'app/utils/appHelpers';
import axios from 'axios';
import config from '../../config';
import { getObjectListByPropertyApi } from 'api/general';
import { MEETING_USER } from 'app/utils/constants/customConstant';


export const getUserListApi = async (meetingId, userList) => {
   let data = [];
   const resMeetingUserList = await getObjectListByPropertyApi(MEETING_USER, "meetingId", meetingId);

   resMeetingUserList.data.forEach(element => {
      const user = userList.find(item => (item.id === element.userId));
      element.user = user;
      data.push(element);
   });
   data = sortByProperty(data, "indexNo")
   return data;

}

export const getMeetingNoFromUnitIdApi = async (unitId) => {

   const url = `${config.apiUrl}/v1/meeting/getMeetingNoFromUnitId/${unitId}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}



export const postUploadAgendaFileApi = async (formData) => {
   try {
      const url = `${config.apiUrl}/v1/file/upload/agendaFile/`;

      return await axios.post(url, formData, getAxiosConfigUserToken())
         .then(response => response.data);



   } catch (err) {
      if (err.response.status === 500) {
         console.log("Sunucu problemi var")
         return { status: false, errorMessage: "Sunucu problemi var" }
      }
      else {
         //console.log(err.response.data.msg);
         return { status: false, errorMessage: err.response.data.msg }
      }
   }
}

export const postMoveDecisionFilesApi = async (data) => {
   try {
      const url = `${config.apiUrl}/v1/file/moveDecisionFiles`;
      return await axios.post(url, data, getAxiosConfigUserToken())
         .then(response => response.data);
   } catch (err) {
      if (err.response?.status === 500) {
         return { status: false, errorMessage: "Sunucu problemi var" }
      }
      return { status: false, errorMessage: err.response?.data?.errorMessage || "Bilinmeyen hata" }
   }
}

export const postUploadPeriodicReportFileApi = async (formData) => {
   try {
      const url = `${config.apiUrl}/v1/file/upload/periodicReportFile/`;
      return await axios.post(url, formData, getAxiosConfigUserToken()).then(response => response.data)

   } catch (err) {
      if (err.response.status === 500) {
         console.log("Sunucu problemi var")
         return { status: false, errorMessage: "Sunucu problemi var" }
      }
      else {
         return { status: false, errorMessage: err.response.data.msg }
      }
   }
}

export const deletePeriodicReportFileApi = async (filePath) => {
   const url = `${config.apiUrl}/v1/file/delete/periodicReportFile/`;
   return await axios.delete(url, {
      ...getAxiosConfigUserToken(),
      data: { filePath }
   }).then(response => response.data);

}

export const getMeetingDashboardInfoFromUserIdApi = async (userId, type = "uye") => {

   const url = `${config.apiUrl}/v1/meeting/getMeetingDashboardInfoFromUserId/${userId}/${type}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}

export const getDashboardVoteInfoFromUserIdApi = async (userId) => {

   const url = `${config.apiUrl}/v1/meeting/getDashboardVoteInfoFromUserId/${userId}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}

export const getDashboardUserCountInfoApi = async (userId, byInstArray) => {

   const url = `${config.apiUrl}/v1/meeting/getDashboardUserCountInfo/${userId}/${byInstArray}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}
export const getParticipantDashboardInfoFromUserIdApi = async (userId) => {

   const url = `${config.apiUrl}/v1/meeting/getParticipantDashboardInfoFromUserId/${userId}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}


export const getDashboardMeetingCountInfoApi = async (userId, instArray) => {

   const url = `${config.apiUrl}/v1/meeting/getDashboardMeetingCountInfo/${userId}/${instArray}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}
export const getDashboardMeetingCountInfoByUnitsApi = async (userId, roleGroups) => {

   const url = `${config.apiUrl}/v1/meeting/getDashboardMeetingCountInfoByUnits/${userId}/${roleGroups}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}

export const getDashboardAllInstMeetingCountsApi = async () => {
   const url = `${config.apiUrl}/v1/meeting/getDashboardAllInstMeetingCounts`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}

export const getMeetingPreviousUsersFromUnitIdApi = async (byUnitId, byMeetingNo) => {

   const url = `${config.apiUrl}/v1/meeting/getMeetingPreviousUsersFromUnitId`
   const params = {
      byUnitId: byUnitId,
      byMeetingNo: byMeetingNo
   }
   return await axios.get(url, {
      ...getAxiosConfigUserToken(),
      params
   }).then(response => response.data.data

   )
}

// BAK !!!!
export const getSubjectGroupCountsByMeetingIdApi = async (byMeetingId) => {

   const url = `${config.apiUrl}/v1/meeting/getSubjectGroupCountsByMeetingId/${byMeetingId}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data

   )
}
export const getSubjectGroupCountsByFilterApi = async (params) => {
   const url = `${config.apiUrl}/v1/meeting/getSubjectGroupCountsByFilter/`;
   return await axios.get(url, {
      ...getAxiosConfigUserToken(),
      params
   }).then(response => response.data);
}


export const postMeetingVideoCallStartApi = async (meeting) => {
   const url = `${config.apiUrl}/v1/meeting/videoCall/start`;
   return await axios.post(url, meeting, getAxiosConfigUserToken()).then(response => response.data);

}

export const postMeetingVideoCallRecordApi = async (meeting) => {
   const url = `${config.apiUrl}/v1/meeting/videoCall/record`;
   return await axios.post(url, meeting, getAxiosConfigUserToken()).then(response => response.data);

}

export const getDecisionStatusListApi = async (searchParams) => {
   const url = `${config.apiUrl}/v1/meeting/getDecisionStatusList`;

   return await axios
      .get(url, {
         ...getAxiosConfigUserToken(),
         params: searchParams,
      })
      .then((response) => response.data);
};

export const getDetailSearchListApi = async (searchParams) => {
   const url = `${config.apiUrl}/v1/meeting/getDetailSearchList`;

   return await axios
      .get(url, {
         ...getAxiosConfigUserToken(),
         params: searchParams,
      })
      .then((response) => response.data);
};

export const isTherePeriodicReportApi = async (unitId) => {
   const url = `${config.apiUrl}/v1/meeting/isTherePeriodicReport/${unitId}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data);
}

export const isThereSameMeetingNoApi = async (unitId, meetingNo) => {
   const url = `${config.apiUrl}/v1/meeting/isThereSameMeetingNo/${unitId}/${meetingNo}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data);
}


export const getDecisionStatusListToolBarApi = async (searchParams) => {
   const url = `${config.apiUrl}/v1/meeting/getDecisionStatusListToolBar`;
   return await axios
      .get(url, {
         ...getAxiosConfigUserToken(),
         params: { ...searchParams },
      })
      .then((response) => response.data);
};
export const getDetailSearchListToolBarApi = async (searchParams) => {
   const url = `${config.apiUrl}/v1/meeting/getDetailSearchListToolBar`;
   return await axios
      .get(url, {
         ...getAxiosConfigUserToken(),
         params: { ...searchParams },
      })
      .then((response) => response.data);
};


export const getMeetingListFromAuthUserIdApi = async (type) => {
   const url = `${config.apiUrl}/v1/meeting/getMeetingListFromAuthUserId/${type}`;

   return await axios
      .get(url, {
         ...getAxiosConfigUserToken()
      })
      .then((response) => response.data);
};
export const getReadMeetingListFromAuthUserIdApi = async () => {
   const url = `${config.apiUrl}/v1/meeting/readMeetingListFromAuthUserId`;

   return await axios
      .get(url, {
         ...getAxiosConfigUserToken()
      })
      .then((response) => response.data);
};


export const getUserPartcMeetingListFromAuthUserIdApi = async () => {
   const url = `${config.apiUrl}/v1/meeting/getUserPartcMeetingListFromAuthUserId`;

   return await axios
      .get(url, {
         ...getAxiosConfigUserToken()
      })
      .then((response) => response.data);
};

export const controlOfAllUserInputs = async (meetingId, type) => {
   const url = `${config.apiUrl}/v1/meeting/controlOfAllUserInputs/${meetingId}/${type}`;
   return await axios.get(url, getAxiosConfigUserToken()).then(response => response.data);
}

export const getUserPeriodicReportListApi = async () => {
   const url = `${config.apiUrl}/v1/meeting/getUserPeriodicReportList`;
   return await axios.get(url, getAxiosConfigUserToken())
      .then(response => response.data)
}

export const postBulkVoteActionApi = async (data) => {
   const url = `${config.apiUrl}/v1/meeting/bulkVoteAction`;
   return await axios.post(url, data, getAxiosConfigUserToken())
      .then(response => response.data)
}